<template>
  <div  >
    <Header></Header>
    <Title title="角色列表"></Title>
    <div class="contain_main">
      <div class="search" @keydown.enter="getlist">
        <div class="search_item">
          <div class="item">
            <span>角色名:</span>
            <Input v-model="data.name" placeholder="请输入..." style="width:2rem"/>
          </div>
          <div class="item">
            <div class="button" @click="getlist">搜索</div>
          </div>
          <div class="item">
            <div class="button" @click="showed=true;type=1">添加</div>
          </div>
        </div>
      </div>
      <div class="table">
        <table>
          <thead>
            <tr>
              <td>序号</td>
              <td>角色名称</td>
              <td>描述</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in list" :key="index">
              <td>{{item.id}}</td>
              <td>{{item.title}}</td>
              <td>{{item.description}}</td>
              <td>
                <Button size="small" @click="edit(item)" type="primary">编辑</Button>
                <Button
                  size="small"
                  type="success"
                  @click="$router.push('/powerset?id='+item.id)"
                >权限</Button>
                <!-- <Button size="small" @click="del" type="error">删除</Button> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div></div>
    <grounpmanage v-if="showed" :type="type" :dataset="message" @success="success" @close="close"></grounpmanage>
  </div>
</template>
<script>
import Header from "../../components/header";
import Title from "../../components/title";
import { Auths_index, Auths_del } from "../../assets/js/api.js";
import grounpmanage from "../../components/toast/grounpmanage";
export default {
  name: "testlist",
  data() {
    return {
      data: {
        // 名称	类型	必填	参数位置	默认值	备注
        name: null
      },
      list: [],
      showed: false,
      type: 1,
      message: null
    };
  },
  mounted() {
    this.getlist();
  },
  filters: {
    status(value) {
      switch (value) {
        case 1:
          return "正常";
        case 0:
          return "停用";
        case 2:
          return "冻结";
      }
    }
  },
  components: {
    Header,
    Title,
    grounpmanage
  },
  methods: {
    close() {
      this.showed = false;
    },
    success() {
      this.close();
      this.getlist();
    },
    getlist() {
      Auths_index(this.data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data;
        }
      });
    },
    edit(data) {
      this.type = 2;
      this.message = data;
      this.showed = true;
    },
    del(data) {
      if (!confirm("您确定删除该条信息？")) return;
      Auths_del({ id: data }).then(res => {
        if (res.data.code == 200) {
          this.$Notice.success({ title: "成功提示", desc: "删除成功！" });
          this.getlist();
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    },
    add() {}
  }
};
</script>
<style lang="css" scoped>
/* 搜索栏样式------------------------------------------------------------------------------------------- */
.search {
  margin-top: 0.2rem;
  display: flex;
  color: #575e6b;
}
.search .search_item {
  display: flex;
}
.search .search_item .item {
  margin: 0 0.15rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
/* 表格栏目样式----------------------------------------------------------------------------------------------*/
.table {
  margin-top: 0.6rem;
  font-size: 0.14rem;
}
table {
  width: 100%;
}
thead tr {
  color: #a4acbf;
}
tbody tr {
  color: #707788;
}
tr {
  height: 0.6rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/system/powerlist.vue